module.exports = __webpack_public_path__ + "static/media/blog.ce7ae91c.png";